"use strict";

exports.__esModule = !0, exports.default = void 0;
var _react = _interopRequireDefault(require("react")),
  _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}
function _inheritsLoose(a, b) {
  a.prototype = Object.create(b.prototype), a.prototype.constructor = a, _setPrototypeOf(a, b);
}
function _setPrototypeOf(a, b) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (a, b) {
    return a.__proto__ = b, a;
  }, _setPrototypeOf(a, b);
}
var ClickOutside = /*#__PURE__*/function (a) {
    function b() {
      for (var b, c = arguments.length, d = Array(c), e = 0; e < c; e++) d[e] = arguments[e];
      return b = a.call.apply(a, [this].concat(d)) || this, b.container = /*#__PURE__*/_react.default.createRef(), b.handleClick = function (a) {
        var c = b.container.current,
          d = a.target,
          e = b.props.onClickOutside;
        (c && c === d || c && !c.contains(d)) && e(a);
      }, b;
    }
    _inheritsLoose(b, a);
    var c = b.prototype;
    return c.componentDidMount = function componentDidMount() {
      document.addEventListener("click", this.handleClick, !0);
    }, c.componentWillUnmount = function componentWillUnmount() {
      document.removeEventListener("click", this.handleClick, !0);
    }, c.render = function render() {
      var a = this.props,
        b = a.className,
        c = a.children;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: b,
        ref: this.container
      }, c);
    }, b;
  }(_react.default.Component),
  _default = ClickOutside;
exports.default = _default;